module.exports = __webpack_public_path__ + "static/img/graphapi-serverless-graphql.9603a72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/graphapi-serverless-graphql.svg
// module id = /EO9
// module chunks = 0